import React, { useEffect, useMemo, useState } from 'react'
import IPInput from '../../../../../components/IPInput'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { useCustomReducer } from '../../../../../base/customHooks'
import Table from '../../../../../components/Table'
import Swal from 'sweetalert2'
import IPButton from '../../../../../components/IPButton'
import { GetFibaListApi } from '../services/getFibaListApi'
import { IFibaRequest, IFibaResponse } from '../models/model'

interface IFibaInsuranceListState {
  dealerCode: string
}

function Index(props: BaseComponentWithContextProps) {

  const getInitialState = (): IFibaInsuranceListState => {
    return {
      dealerCode: '',
    }
  }
  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IFibaInsuranceListState>(intialState)

  const [fibaList, setFibaList] = useState<IFibaResponse[]>([])

  const getFibaList = () => {
    props.showLoading();

    const fibaApi: GetFibaListApi = new GetFibaListApi({})

    const req: IFibaRequest = {
      DealerCode: state.dealerCode,
    }
    try {
      fibaApi.getFibaList(req).then(res => {
        if (res) {
          setFibaList(res)
        } else {
          setFibaList([])
        }
        props.hideLoading();
      }).catch(err => {
        props.hideLoading();
        Swal.fire({
          icon: 'error',
          title: err?.description || 'Fiba sigorta listesi alınırken bir hata oluştu.',
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      })
    } catch (err: any) {
      props.hideLoading();
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Fiba sigorta listesi alınırken bir hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    }
  };

  useEffect(() => {
    getFibaList()
  }, [])



  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'order',
      },
      {
        Header: 'Poliçe No',
        accessor: 'PoliceId',
      },
      {
        Header: 'Başlama Tarihi',
        accessor: 'BaslamaTarihi',
      },
      {
        Header: 'TCKN',
        accessor: 'Tckn',
      },
      {
        Header: 'Ad-Soyad',
        accessor: 'Adsoyad',
      },
      {
        Header: 'Uzatılmış Garanti Süresi',
        accessor: 'Uzatilmisgarantisuresi',
      },
      {
        Header: 'Brüt',
        accessor: 'Brut',
      },
      {
        Header: 'Acente Kod',
        accessor: 'AcenteKod',
      },
      {
        Header: 'Acente Adı',
        accessor: 'AcenteAdi',
      },
      {
        Header: 'Poliçe Hareket ID',
        accessor: 'PoliceHareketId',
      },
      {
        Header: 'Paket Adı',
        accessor: 'PaketAdi',
      },
      {
        Header: 'Durum Kod',
        accessor: 'DurumKod',
      },
      {
        Header: 'Durum Açıklama',
        accessor: 'DurumAciklama',
      },
      {
        Header: 'Ek Belge No',
        accessor: 'EkbelgeNo',
      },
      {
        Header: 'Ek Belge Kod',
        accessor: 'EkbelgeKod',
      },
      {
        Header: 'Ek Belge Açıklama',
        accessor: 'EkbelgeAciklama',
      },
      {
        Header: 'Tanzim Tarihi',
        accessor: 'TanzimTarihi',
      },
      {
        Header: 'Onay Saat-Dakika',
        accessor: 'Onaysaatdakika',
      },
      {
        Header: 'Sistem Kullanıcısı',
        accessor: 'SistemKullanicisi',
      },
      {
        Header: 'Ürün Kategori Kodu',
        accessor: 'Urunkategorikodu',
      },
      {
        Header: 'Mağaza',
        accessor: 'Magaza',
      },
      {
        Header: 'Ürün Kategori Adı',
        accessor: 'Urunkategoriadi',
      },
      {
        Header: 'Cihaz Markası',
        accessor: 'CihazMarkasi',
      },
      {
        Header: 'Model Bilgisi',
        accessor: 'ModelBilgisi',
      },
      {
        Header: 'Cihaz Bedeli',
        accessor: 'CihazBedeli',
      },
      {
        Header: 'Personel',
        accessor: 'Personel',
      },
      {
        Header: 'Seri No',
        accessor: 'Serino',
      },
      {
        Header: 'IMEI No',
        accessor: 'Imeino',
      },
    ],
    []
  )


  const tableData = useMemo(
    () =>
      fibaList.map((item, index) => {
        const data = {
          order: index + 1,
          PoliceId: item.PoliceId,
          BaslamaTarihi: item.BaslamaTarihi,
          Tckn: item.Tckn,
          Adsoyad: item.Adsoyad,
          Uzatilmisgarantisuresi: item.Uzatilmisgarantisuresi,
          Brut: item.Brut,
          AcenteKod: item.AcenteKod,
          AcenteAdi: item.AcenteAdi,
          PoliceHareketId: item.PoliceHareketId,
          DurumKod: item.DurumKod,
          DurumAciklama: item.DurumAciklama,
          EkbelgeNo: item.EkbelgeNo,
          EkbelgeKod: item.EkbelgeKod,
          EkbelgeAciklama: item.EkbelgeAciklama,
          TanzimTarihi: item.TanzimTarihi,
          Onaysaatdakika: item.Onaysaatdakika,
          SistemKullanicisi: item.SistemKullanicisi,
          Urunkategorikodu: item.Urunkategorikodu,
          Magaza: item.Magaza,
          Urunkategoriadi: item.Urunkategoriadi,
          Personel: item.Personel,
          Serino: item.Serino,
          Imeino: item.Imeino,
          CihazMarkasi: item.CihazMarkasi,
          ModelBilgisi: item.ModelBilgisi,
          PaketAdi: item.PaketAdi,
          CihazBedeli: item.CihazBedeli,
        }
        return data
      }),
    [fibaList]
  )

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center mb-2'>
            <div className='col-lg-10 d-flex align-items-center'>
              <h4>Fiba Sigorta Listesi</h4>
            </div>
          </div>
          <div className='row ml-2 mr-2'>
            <div className='col-lg-2'>
              <label htmlFor='dealerCode' className='form-label'>
                Bayi Kodu
              </label>
              <IPInput
                type='text'
                className='form-control'
                name='dealerCode'
                placeholder='Bayi Kodu'
                onChange={(e) => setState({ dealerCode: String(e.target.value).trim() })}
                value={state.dealerCode}
              />
            </div>
            <div className='col-lg-1 mt-5'>
              <IPButton text={'Göster'}
                type='button' className='btn btn-primary'
                onClick={() => getFibaList()} />
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <div className='col-lg-12'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <Table columns={tableColumns} data={tableData} currentPage={0} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(Index)